import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#3F3273',
      light: '#9747FF'
    },
    text: {
      primary: '#483359',
      secondary: '#626262'
    },
    error: {
      main: '#D32F2F'
    },
    background: {
      paper: '#ffffff'
    }
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
    allVariants: {
      color: '#483359'
    },
    body1: {
      fontSize: 16,
      fontWeight: 400
    },
    body2: {
      color: '#626262',
      fontSize: 14
    },
    h1: {
      fontSize: 28,
      fontWeight: 600
    },
    h2: {
      fontSize: 24,
      fontWeight: 500
    },
    caption: {
      fontWeight: 600,
      fontSize: 16
    },
    subtitle1: {
      fontWeight: 600,
      color: 'white'
    },
    h5: {
      fontSize: 14,
      fontWeight: 600
    }
  },

  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          marginBottom: 8,
          '&.Mui-selected': {
            backgroundColor: '#524086',
            '&:hover': {
              backgroundColor: '#524086'
            }
          }
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          width: 280,
          backgroundColor: '#3F3273',
          color: '#ffffff',
          borderRight: 'none'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          backgroundColor: '#ffffff',
          paddingRight: 1,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#CFCFCF',
            borderWidth: 1
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#B0B0B0',
            borderWidth: 1
          }
        },
        notchedOutline: {
          borderColor: '#DFDCDB',
          borderWidth: 1
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: '#9E9E9E'
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          width: '100%',
          fontWeight: 400,
          fontSize: 20,
          lineHeight: '30px',
          letterSpacing: '0%',
          marginBottom: '16px',
          color: '#483359'
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'black',
          color: 'white',
          fontSize: 14,
          textAlign: 'center',
        }
      }
    }
  }
});
